import { render, staticRenderFns } from "./Among.vue?vue&type=template&id=6b43807c&scoped=true&"
import script from "./Among.vue?vue&type=script&lang=js&"
export * from "./Among.vue?vue&type=script&lang=js&"
import style0 from "./Among.vue?vue&type=style&index=0&id=6b43807c&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b43807c",
  null
  
)

export default component.exports